import type { SampleTemplateRef } from '@capture/shared';

interface Props {
  samples: SampleTemplateRef[];
  onUpload: (file: File) => void;
  onDelete: (id: string) => void;
}

export function SamplesUploader({ samples, onUpload, onDelete }: Props) {
  function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (file) {
      onUpload(file);
      e.target.value = '';
    }
  }

  return (
    <div className="samples-uploader">
      <h3 className="samples-uploader__title">SAMPLE TEMPLATES</h3>
      <div className="samples-uploader__grid">
        {samples.map((sample) => (
          <div key={sample.id} className="samples-uploader__card">
            <span className="samples-uploader__info">
              {sample.pageCount} page{sample.pageCount !== 1 ? 's' : ''}
            </span>
            <button
              type="button"
              className="samples-uploader__delete"
              onClick={() => onDelete(sample.id)}
            >
              Delete
            </button>
          </div>
        ))}
      </div>
      <label className="samples-uploader__upload-label">
        Upload sample
        <input
          type="file"
          className="samples-uploader__file-input"
          onChange={handleFileChange}
          accept="image/*,application/pdf"
        />
      </label>
    </div>
  );
}
